/**
 * Alpha CTA tracking — records clicks on the storefront controls added in the
 * 2026-09 conversion work as `alpha_cta` rows in the loyalty app's pixel table.
 *
 * Why not Shopify.analytics.publish(): the Alpha Pixel subscribes to
 * `all_events`, but custom events published from the page never reached the
 * collector in testing (verified 2026-09-05), and the ingest now drops DOM
 * `clicked` events, so element ids cannot be used either. The loyalty chat
 * widget already beacons its popup_* funnel straight to /pixel-collect with the
 * same clientId the Web Pixel uses (`_shopify_y`), so this does the same.
 *
 * Anything tagged `data-alpha-cta="<name>"` emits one event. Names in use:
 * bundle_add, bundle_sticky_add, bundle_group, attach_add, top3_add,
 * cat_can_own_add, cart_gap_add, bundle_nudge, benz_pill, litter_hub_link.
 *
 * Query: select json_extract(data,'$.cta'), count(*) from PixelEvent
 *        where name='alpha_cta' group by 1;
 */
(function () {
  'use strict';

  var SHOP = (window.Shopify && window.Shopify.shop) || 'alphapetstw.myshopify.com';
  var API = '/apps/loyalty/api';
  var KEY_STORAGE = 'alpha_engage_key::' + SHOP;   // shared with chat-bubble.js
  var CID_STORAGE = 'alpha_engage_cid';            // shared with chat-bubble.js

  function cookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }

  function clientId() {
    var y = cookie('_shopify_y');
    if (y) return y;
    var v = '';
    try { v = localStorage.getItem(CID_STORAGE) || ''; } catch (e) { /* ignore */ }
    if (!v) {
      v = 'ec_' + ((window.crypto && crypto.randomUUID) ? crypto.randomUUID() : Date.now() + '_' + Math.random().toString(36).slice(2, 10));
      try { localStorage.setItem(CID_STORAGE, v); } catch (e) { /* ignore */ }
    }
    return v;
  }

  var keyPromise = null;
  function ingestKey() {
    try {
      var cached = localStorage.getItem(KEY_STORAGE);
      if (cached) return Promise.resolve(cached);
    } catch (e) { /* ignore */ }
    if (!keyPromise) {
      keyPromise = fetch(API + '/chat?shop=' + encodeURIComponent(SHOP) + '&mode=config', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var k = (j && (j.ingestKey || (j.config && j.config.ingestKey))) || '';
          if (k) { try { localStorage.setItem(KEY_STORAGE, k); } catch (e) { /* ignore */ } }
          return k;
        })
        .catch(function () { return ''; });
    }
    return keyPromise;
  }

  function customerId() {
    var c = window.cartDrawerCustomer;
    return c && c.id ? String(c.id) : null;
  }

  function send(cta, detail) {
    var cid = clientId();
    var ev = {
      id: cid + ':alpha_cta:' + cta + ':' + Date.now(),
      name: 'alpha_cta',
      type: 'custom',
      ts: new Date().toISOString(),
      clientId: cid,
      url: location.href,
      path: location.pathname,
      title: document.title,
      referrer: document.referrer || '',
      viewport: window.innerWidth + 'x' + window.innerHeight,
      userAgent: navigator.userAgent,
      data: { cta: cta, product: detail.product, variant: detail.variant, value: detail.value }
    };
    var cust = customerId();
    if (cust) ev.customerId = cust;

    ingestKey().then(function (key) {
      var payload = { shop: SHOP, events: [ev] };
      if (key) payload.ingestKey = key;
      var body = JSON.stringify(payload);
      var url = API + '/pixel-collect';
      try {
        if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }))) return;
      } catch (e) { /* fall through */ }
      try {
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: body, keepalive: true, credentials: 'same-origin' })
          .catch(function () { /* telemetry is best-effort */ });
      } catch (e) { /* ignore */ }
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest('[data-alpha-cta]');
    if (!el) return;
    var cta = el.getAttribute('data-alpha-cta');
    if (!cta) return;
    var card = el.closest('[data-alpha-product]');
    send(cta, {
      product: (el.getAttribute('data-alpha-product') || (card && card.getAttribute('data-alpha-product')) || '').slice(0, 120),
      variant: (el.getAttribute('data-variant-id') || '').slice(0, 32),
      value: (el.getAttribute('data-alpha-value') || '').slice(0, 64)
    });
  }, true);

  // Warm the key so the first click does not wait on a config fetch.
  if (document.readyState === 'complete') ingestKey(); else window.addEventListener('load', function () { ingestKey(); });
})();
